/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Especifica el tipo de destinos validos para opiniones
 */
export type TipoDestinoDeOpinion = 'empresa' | 'actividad' | 'evento' | 'programacion';

export const TipoDestinoDeOpinion = {
    Empresa: 'empresa' as TipoDestinoDeOpinion,
    Actividad: 'actividad' as TipoDestinoDeOpinion,
    Evento: 'evento' as TipoDestinoDeOpinion,
    Programacion: 'programacion' as TipoDestinoDeOpinion
};

